var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-page-shell',{attrs:{"title":"驳回单"}},[_c('order-workbench',{attrs:{"show-title":false,"show-create-button":false,"extra-query-params":{ reject_resubmit_list: 1 },"list-table-variant":'tax_cleared'}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e5dbe94","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/RejectResubmitList.vue
// module id = 6WAs
// module chunks = 0